import { HttpParams } from '@angular/common/http';
import { ApplicationContext } from '../model';

export function contextToParams(
  ctx: Pick<ApplicationContext, 'clientId' | 'entityId' | 'clientTaxPeriodId' | 'reportingGroupId'>
): HttpParams {
  let params = new HttpParams()
    .set('clientId', ctx.clientId)
    .set('clientTaxPeriodId', ctx.clientTaxPeriodId.toString());

  if (ctx.entityId) {
    params = params.set('entityId', ctx.entityId);
  }

  if (ctx.reportingGroupId) {
    params = params.set('reportingGroupId', ctx.reportingGroupId);
  }

  return params;
}

export function rgContextToParams(
  ctx: Pick<ApplicationContext, 'clientId' | 'clientTaxPeriodId' | 'reportingGroupId'>
): HttpParams {
  return new HttpParams({
    fromObject: {
      clientId: ctx.clientId,
      clientTaxPeriodId: ctx.clientTaxPeriodId,
      reportingGroupId: ctx.reportingGroupId ?? '',
    },
  });
}
